import wixWindow from 'wix-window';

$w.onReady(function () {
	//multilingual
    let lang = wixWindow.multilingual.currentLanguage;
    /*if (lang === 'en') {
        //store categories
        $w("#hebCats").hide();
        $w("#engCats").show();
    }*/
});